export const filterSearchParams = (
	searchParams: URLSearchParams,
	paramsToPreserve: string[]
) =>
	new URLSearchParams(
		paramsToPreserve
			.map((param) => [param, searchParams.get(param)])
			.filter(([, value]) => value !== null) as [string, string][]
	);
